import '../accordion/index.js';
import '../contextmenu/index.js';
import '../datatable/index.js';
import '../docker/index.js';
import '../doubleclick/index.js';
import '../draggable/index.js';
import '../droppable/index.js';
import '../inlineedit/index.js';
import '../layout/index.js';
import '../menu/index.js';
import '../pager/index.js';
import '../resizable/index.js';
import '../rightclick/index.js';
import '../select/index.js';
import '../sortable/index.js';
import '../tabs/index.js';
import '../tree/index.js';
import '../utilities/index.js';
import '../window/index.js';
